import {
    getAllSponsorRequest,
    getSponsorByIdRequest,
} from "../repositories/sponsor_repository";

export const SponsorService = () => {
    const fetchAllSponsor = async (setSponsorList) => {
        try {
            const response = await getAllSponsorRequest();
            if (response?.success) {
                setSponsorList(response.data);
            } else {
                console.error("Failed to fetch sponsors : ", response?.errors);
            }
        } catch (error) {
            console.error("Failed to fetch sponsors data ; ",error);
        }
    };

    const fetchSponsorById = async (id) => {
        try {
            const response = await getSponsorByIdRequest(id);
            if (response?.success) {
                return response.data;
            } else {
                console.error("Failed to fetch sponsor details : ", response?.errors);
                throw new Error(response?.errors || "Failed to fetch sponor details.");
            }
        } catch (error) {
            console.error("Error in fetch sponsor by id : ", error);
            throw error;
        }
    };

    return {
        fetchAllSponsor,
        fetchSponsorById,
    }
}